import {combineReducers} from 'redux';

import eventScheduleReducer from './event-schedule-slice';
import eventPricingDefaultsReducer from './event-pricing-defaults-slice';
import pastEventsListReducer from './past-events-list-slice';
import dayOverviewReducer from 'pages/event-management/store/day-overview-slice';
import eventOptOutWizardReducer from 'pages/event-management/schedule/event-opt-out-wizard/store/event-opt-out-wizard-slice';

const eventsReducer = combineReducers({
    eventSchedule: eventScheduleReducer,
    eventPricingDefaults: eventPricingDefaultsReducer,
    pastEvents: pastEventsListReducer,
    dayOverview: dayOverviewReducer,
    eventOptOutWizard: eventOptOutWizardReducer,
});

export default eventsReducer;
